export default "__VITE_ASSET__CNx7uQrs__"